import { ENGAGEMENT_PEAK_TIME } from './../config';

const reducer = (state = null, action) => {
    switch (action.type) {
        case ENGAGEMENT_PEAK_TIME:
            return action.payload;
        default:
            return state;
    }
}

export default reducer;
